import Layout from '@/View/HRM/layout/layout.vue'
export const HRM = {
  // HRM dashboard Start
  path: '/hrm',
  component: Layout,
  hidden: false,
  redirect: '/hrm/dashboard',
  name: 'HRM',
  meta: {
    breadCrumb: 'HRM',
    title: 'dashboards',
    icon: 'dashboard',
    selected: false,
    permission: ''
  },
  children: [{
    path: '/hrm/dashboard',
    component: () => import('@/View/HRM/dashboard/dashboard.vue'),
    name: 'HRMDashboard',
    meta: {
      breadCrumb: 'Dashboard',
      icon: 'dashboard',
      title: 'Dashboard',
      selected: false,
      permissionList: []
    }
  },
  { // User Object Start
    path: '/hrm/user',
    component: () => import('@/View/HRM/Main/mainview.vue'),
    hidden: false,
    redirect: '/hrm/user/userlist',
    name: 'UserList',
    meta: {
      breadCrumb: 'User',
      title: 'Users',
      selected: false,
      permissionList: []
    },
    children: [{
      path: '/hrm/user/userlist',
      component: () => import('@/View/HRM/user/userlist.vue'),
      name: 'UserList',
      meta: {
        breadCrumb: 'Users',
        icon: '',
        title: 'UsersList',
        selected: false,
        permissionList: []
      }
    },
    {
      path: '/hrm/user/adduser',
      component: () => import('@/View/HRM/user/newuser.vue'),
      name: 'newUser',
      meta: {
        breadCrumb: 'add',
        icon: '',
        title: 'New User',
        selected: false,
        permissionList: []
      }
    },
    {
      path: '/hrm/user/details/:staffId',
      component: () => import('@/View/HRM/user/userdetails.vue'),
      name: 'Userdetails',
      meta: {
        breadCrumb: 'details',
        icon: '',
        title: 'User Details',
        selected: false,
        permissionList: []
      }
    }]
  }]
}



// WEBPACK FOOTER //
// ./src/View/HRM/router/index.js